import React, { Component } from "react";
import { Form, Button, InputGroup, Container, FormControl, Card } from "react-bootstrap";
import Web3 from "web3";
import axios from 'axios';
import emailjs from 'emailjs-com';
import Web3Modal from 'web3modal';
import WalletConnectProvider from "@walletconnect/web3-provider";

import "./App.css";

class App extends Component {

  state = {
    web3: null,
    provider: null,
    accounts: null,
    isWalletConnected: false,
    bscAddress: "",
    email: "",
    discordId: "",
    tgUsername: "",
    price: 0.05,
    amount: 1,
    validated: false,
    purchasePending: false
  };

  componentDidMount = async () => {
    const providerOptions = {
      walletconnect: {
        package: WalletConnectProvider, // required
        options: {
          infuraId: "43e7c1b12410407880552f46b67d3e30"
        }
      }
    };

    const web3Modal = new Web3Modal({
      providerOptions // required
    });

    web3Modal.clearCachedProvider();

    this.setState({ provider: web3Modal, isWalletConnected: false });
  }

  isWalletConnected = async (web3) => {

    let isWalletConnected = false;
    const accounts = await web3.eth.getAccounts();

    if (accounts.length > 0) {
      isWalletConnected = true;
    }

    this.setState({ isWalletConnected: isWalletConnected, accounts: accounts });
  }

  handleAddressChange = (event) => {
    if (!event.target.value || event.target.value.toString().lenght < 42) {
      this.setState({ valid: false });
    }
    this.setState({ bscAddress: event.target.value });
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleAmount = (event) => {
    this.setState({ amount: event.target.value });
  }

  handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      this.purchase()
    }

    this.setState({ validated: true });
  }

  validateAddress = async () => {

    const minABI = [
      {
        constant: true,
        inputs: [{ name: "_owner", type: "address" }],
        name: "balanceOf",
        outputs: [{ name: "balance", type: "uint256" }],
        type: "function",
      }
    ];

    const tokenAddress = "0x9abDbA20EdFbA06B782126b4D8d72A5853918FD0";
    const web3 = new Web3("https://bsc-dataseed1.binance.org:443");
    let price = 0.05;
    let valid = false;
    let validText = "the provided address doesn't hold any $TABOO, please verify";

    try {
      const ctr = new web3.eth.Contract(minABI, tokenAddress);
      const result = await ctr.methods.balanceOf(this.state.bscAddress).call();
      const format = web3.utils.fromWei(result);
      if (format > 0) {
        // Update state with the result.
        price = 0.035;
        valid = true;
        validText = "You are eligible for a TABOOPUNK price reduction! Thank you for holding $TABOO"
      }
      this.setState({ price: price, valid: valid, validText: validText });
    } catch (error) {

    }

    this.setState({ price: price, valid: valid, validText: validText });

  };

  connect = async () => {

    const { provider } = this.state;

    const web3Provider = await provider.connect();

    if (web3Provider) {
      const web3 = new Web3(web3Provider);

      provider.on("disconnect", (error) => {
        this.setState({ web3: null, accounts: null, isWalletConnected: false });
        if (error) {
          console.log(error);
        }
      });

      const accounts = await web3.eth.getAccounts();
      this.setState({ web3: web3, accounts: accounts, isWalletConnected: true });

    } else {
      this.setState({ web3: null, accounts: null, isWalletConnected: false });
    }

  }

  purchase = async () => {

    let network;
    const { web3, isWalletConnected, accounts } = this.state;

    if (isWalletConnected && this.state.amount > 0) {
      if (web3) {
        network = await web3.eth.net.getNetworkType();
      }

      if (network !== 'main') {
        alert("plese make sure your wallet is connected and  your network is set to Ethereum's Mainnet on metamask");
      } else {
        if (accounts.lenght > 0) {
          this.doPurchase();
        }
        else {
          let accounts = await web3.eth.getAccounts();
          this.setState({ accounts: accounts });
          this.doPurchase();
        }
      }
    }
  }

  doPurchase = async () => {

    const { web3, accounts } = this.state;

    const toAddress = process.env.REACT_APP_TABOOPUNK_ADDRESS;
    const calcAmount = this.state.price * this.state.amount;
    const amount = calcAmount.toString();
    const amountToSend = web3.utils.toWei(amount, "ether");
    const connected = await web3.eth.getAccounts();

    if (connected.length > 0) {
      const send = web3.eth.sendTransaction({
        from: accounts[0],
        to: toAddress,
        value: amountToSend
      })
        .on('transactionHash', (hash) => {
          this.storeData(hash);
          this.sendConfirmationEmail(hash);
          this.setState({
            transactionFullfilled: `Congratulations! you have successfully purchased a taboopunk, an email confirmation will arrive to ${this.state.email} shortly, Check SPAM if you dont see it in your inbox`,
            purchasePending: true
          });
        })
        .on('error', console.error);

    } else {
      alert("No wallet connected");
    }
  }

  storeData = (txid) => {
    axios.post(
      "https://sheet.best/api/sheets/6ee5ead9-f4dd-44dc-9027-9febc4b3e821",
      {
        email: this.state.email,
        discordId: this.state.discordId,
        tgUsername: this.state.tgUsername,
        amount: this.state.amount,
        bscAddress: this.state.bscAddress,
        txId: txid
      }
    )
      .then(function (response) {
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  sendConfirmationEmail = async (hash) => {
    await emailjs.send(
      "service_9mug7sb",
      "template_iw7epik",
      {
        email: this.state.email,
        amount: this.state.amount,
        txId: hash,
        purchasePrice: this.state.price
      },
      "user_iOTbyZD6ZSThfa1kFJjId"
    );
  }

  render() {
    return (
      <div className="App">
        <Container style={{ textAlign: 'center' }}>
          <div className="row">
            <Card className="mx-auto pb-3 mt-lg-5">
              <Card.Body>
                <div className="mainDesc">
                  <h1>TABOOPUNKS</h1>
                  <br />
                  <p style={{ fontSize: "0.9rem" }}>
                    TABOOPUNKS are up to 10,000 uniquely generated characters, no two are exactly alike,
                    and each of them can be officially owned by a single person on the ethereum blockchain.
                    They will have up to 300 attributes across 10 to 20 categories to be entirely unique by at least 3 degrees of separation.
                  </p>
                  <p style={{ fontSize: "0.9rem" }}>
                    Not only are TABOOPUNKS beautifully designed collectible characters,
                    they also can serve as your ticket to the world of exclusive content and VIP parties.
                    They will basically grant you the owner, superpowers on the TABOO marketplace. From invitational private parties with our carefully selected supermodels to access to all areas on the TABOO marketplace and some yet undisclosed utilities.
                  </p>
                  <hr />
                </div>
                <div className="mt-5 pt-5 pb-5 mb-5">
                  <h1>TABOOPUNKS PURCHASES ARE NO LONGER AVAILABLE. </h1>
                  <h1>THANK YOU TO ALL THOSE THAT PURCHASED</h1>
                </div>
              </Card.Body>
            </Card>
          </div>
        </Container>
      </div>
    );
  }
}

export default App;
